import {ShapeCommand} from 'src/app/commands/commands.template';
import {
  ActivityOrgModelNodesAttachmentCreateAction,
  ActivityOrgModelNodesAttachmentDeleteAction
} from 'src/app/shared/models/activity-org-model-nodes-attachment-actions.interface';
import {OrgModelNodesAttachment} from 'src/app/shared/models/org-model-nodes-attachment.interface';

export class ActivityAddOrgModelNodesAttachmentCommand extends ShapeCommand {
  protected services: {[key: string]: any};
  protected object: OrgModelNodesAttachment[];
  private firstAction = true;

  public execute() {
    const action: ActivityOrgModelNodesAttachmentCreateAction = {
      createOrgModelNodesAttachment: this.attachments
    };

    this.firstAction = false;

    return this.services.diagramUpdateSvc.update(action, true, false, false).then(result => {
      this.redrawActivity();

      return result;
    });
  }

  public reverse() {
    const action: ActivityOrgModelNodesAttachmentDeleteAction = {
      deleteOrgModelNodesAttachment: this.attachments
    };

    this.firstAction = true;

    return this.services.diagramUpdateSvc.update(action).then(result => {
      this.redrawActivity();

      return result;
    });
  }

  private get attachments(): OrgModelNodesAttachment[] {
    const {itemMxKey} = this.object[0];
    const activity = this.findActivity(itemMxKey);

    activity.orgModelAttachments = activity.orgModelAttachments ?? [];

    let attached = this.firstAction ? 0 : -this.object.length;

    return this.object.map(attachment => {
      const res = {
        ...attachment,
        mxKey: this.getMxKey(activity.orgModelAttachments) + attached
      };

      attached++;

      return res;
    });
  }

  private findActivity(itemMxKey: string | number) {
    return this.services.jsonHandlerSvc
      .get()
      .activities?.find(attachment => attachment.mxKey === Number(itemMxKey));
  }

  private getMxKey(orgModelAttachments): number {
    let mxKey = 0;

    orgModelAttachments.forEach(attachment => {
      if (attachment.mxKey > mxKey) {
        mxKey = attachment.mxKey;
      }
    });

    return mxKey + 1;
  }

  private redrawActivity(): void {
    const {itemMxKey} = this.object[0];

    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(itemMxKey)
      .comp.instance.setupFromJson();
  }
}
